import GrilleErrorsComponentController from './grille.errors.component.controller';
import Template from './grille.errors.component.tpl.html';

export default {
    bindings: {
        id: '<',
        refreshKey: '<',
        section: '@',
        hasError: '<',
        isLoading: '<',
        mode: '@'
    },
    template: Template,
    controller: GrilleErrorsComponentController
};
